<template>
  <div id="dcotors" class="wrrapper">
    <page-heading title="Doctors"></page-heading>
    <data-table
      :cols="columns"
      :rows="listEmployees"
      height="calc(100vh - 14.5rem)"
      :loading="isLoading"
    >
    </data-table>
  </div>
</template>

<script>
import DataTable from "@/components/DataTable.vue";
import { mapActions, mapGetters } from "vuex";
import { permissionsMiddleWare } from "../../../utils/permissionsMiddleWare";
export default {
  components: {
    DataTable
  },
  data() {
    return {
      isLoading: false,
      columns: [
        { column: "serial", label: "#", width: "60" },
        { column: "full_name", label: "Name", sortable: true },
        { column: "description", label: "Description", sortable: true },
        { column: "mobile_no", label: "Mobile Number", sortable: true },
        { column: "email", label: "Email", sortable: true },
        { column: "created_at", label: "Created At", sortable: true }
      ]
    };
  },
  methods: {
    ...mapActions("user", ["filterEmployees"])
  },
  computed: {
    ...mapGetters("user", ["listEmployees"])
  },
  mounted() {
    if (permissionsMiddleWare("List Doctors")) {
      this.filterEmployees("doctor")
        .then(() => {
          this.isLoading = false;
        })
        .catch(() => (this.isLoading = false));
    } else {
      this.$toasted
        .info(
          "This action cannot be performed by you due to insufficient authorization. Action : List Doctors"
        )
        .goAway("3000");
    }
    setTimeout(() => {
      this.$store.dispatch("auth/userLoginProgress", false);
    }, 3000);
  }
};
</script>

<style scoped>
.wrrapper {
  background: var(--canvas);
  min-height: 100vh;
}
</style>
